











import {
  Component,
  Vue,
  Prop,
} from 'vue-property-decorator';
@Component({
  components: {
  },
})
export default class Placeholder extends Vue {
  @Prop({default: 0}) private height!: number;
  @Prop({default: false}) private condition!: boolean;
  @Prop({default: false}) private small!: boolean;
  @Prop({default: true}) private medium!: boolean;
  @Prop({default: ''}) private addText!: string;
  @Prop({default: ''}) private styles!: string;


}
